const colors = [
  'rgb(71,71,71)',
  'rgb(102,102,102)',
  'rgb(153,153,153)',
  'rgb(187,187,187)',
  'rgb(221,221,221)',
  'rgb(235,88,87)',
  'rgb(255,173,51)',
  'rgb(255,235,53)',
  'rgb(180,238,57)',
  'rgb(84,238,248)',
  'rgb(26,109,222)',
  'rgb(120,72,255)',
  'rgb(251,45,230)',
  'rgb(235,27,39)',
  'rgb(39,205,145)'
]

const backgroundColors = [
  'rgb(197,239,255)',
  'rgb(239,227,255)',
  'rgb(203,247,237)',
  'rgb(255,224,231)',
  'rgb(214,214,214)',
  'rgb(196,255,251)',
  'rgb(255,255,185)',
  'rgb(237,255,202)',
  'rgb(255,207,184)',
  'rgb(229,229,229)'
]

const bookColors = [
  {
    id: 0,
    name: 'blue',
    main: '#1ac1ff',
    accent: '#e5f8ff'
  },
  {
    id: 1,
    name: 'purple',
    main: '#c290ff',
    accent: '#f6efff'
  },
  {
    id: 2,
    name: 'green',
    main: '#4ee3c1',
    accent: '#e4fbf5'
  },
  {
    id: 3,
    name: 'red',
    main: '#fda5bb',
    accent: '#fdeef1'
  },
  {
    id: 4,
    name: 'light-green',
    main: '#13fff1',
    accent: '#dffffe'
  },
  {
    id: 5,
    name: 'yellow',
    main: '#ffff75',
    accent: '#ffffd6'
  },
  {
    id: 6,
    name: 'yellow-green',
    main: '#c2ff4c',
    accent: '#f3fedc'
  },
  {
    id: 7,
    name: 'orange',
    main: '#ffbd41',
    accent: '#fff4e6'
  }
]

export default {
  colors,
  backgroundColors,
  bookColors
}
